const DaysOfWeek = [
    {
        name: "Sunday",
        value: "SUNDAY",
        cronExp: "SUN",
    },
    {
        name: "Monday",
        value: "MONDAY",
        cronExp: "MON",
    },
    {
        name: "Tuesday",
        value: "TUESDAY",
        cronExp: "TUE",
    },
    {
        name: "Wednesday",
        value: "WEDNESDAY",
        cronExp: "WED",
    },
    {
        name: "Thursday",
        value: "THURSDAY",
        cronExp: "THU",
    },
    {
        name: "Friday",
        value: "FRIDAY",
        cronExp: "FRI",
    },
    {
        name: "Saturday",
        value: "SATURDAY",
        cronExp: "SAT",
    },
];

export default DaysOfWeek;
